import React from "react";

import RandingStyle30 from "../../randing/RandingStyle30";

function Randing540({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle30
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      videoSrc="https://d1k8m48tkgq306.cloudfront.net/images/540/01.mp4"
      stepImageBasePath="https://d1k8m48tkgq306.cloudfront.net/images/540"
      companyName="본원"
      privacyCompanyName="검단뉴욕치과의원"
      hideFooter={true}
    />
  );
}

export default Randing540;
